// extracted by mini-css-extract-plugin
module.exports = {"vGutterX":"30px","desktop-up":"(min-width: calc(1280 * 1px))","registration":"Registration_registration__2bXm_","form":"Registration_form__geA2r"};